const Pain = () => {
    return (
        <section className="py-14">
            <div className="max-w-screen-xl mx-auto md:px-8">
                <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                    <div className="flex-1 sm:hidden lg:block">
                        <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" className="md:max-w-lg sm:rounded-lg shadow-2xl" alt="Partners" />
                    </div>
                    <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                        <h3 className="text-indigo-600 font-semibold">
                            You Deserve a Partner, Not Just Another Vendor
                        </h3>
                        <p className="text-gray-800 text-3xl font-bold sm:text-4xl">
                            We Understand Your Pain
                        </p>
                        <p className="mt-3 text-gray-600">
                            Managing properties or warranty claims is stressful, time-consuming, and full of unexpected problems. We’ve worked with dozens of companies like yours — and we’ve seen it all. Here’s what you’re likely facing:
                            <ul className="list-disc p-6">
                                <li>Unreliable Contractors</li>
                                <li>Slow Response = Angry Clients</li>
                                <li>Poor Communication</li>
                                <li>Messy Paperwork & Invoicing</li>
                                <li>Too Many Vendors</li>
                                <li>No One for Emergencies</li>
                            </ul>
                            
                            </p>
                            <h4 className="font-bold text-2xl">It’s Time You Had a Partner Who Gets It</h4>
                            <p>At Matanato, we’ve built our entire business around fixing these exact issues. Scroll down to see how we turn your chaos into confidence</p>
                        <a href="#leadform" className="inline-flex gap-x-1 items-center text-indigo-600 hover:text-indigo-500 duration-150 font-medium">
                            Request a Callback
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Pain;